/* eslint-disable react-hooks/exhaustive-deps */
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { Page, Text, View, Document, StyleSheet, pdf, Font, Image } from "@react-pdf/renderer";
import dayjs from 'dayjs';
import { formatPrice } from '../../utils';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../assets/fonts/rudawregular2.ttf';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import LoanService from '../../services/loanService';
import { useCompany } from '../../provider/companyProvider';
import { fileApiRoute } from "../../services/networkService";

const registerFont = () => {
    Font.register({
        family: 'Rudaw',
        fonts: [{ src: Rudaw, fontWeight: 'normal' }],
    });
};

const PdfLoanList = ({ data }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language !== 'en';
    const [loans, setLoans] = useState([]);
    const [totalDeposit, setTotalDeposit] = useState(0);
    const [totalWithdraw, setTotalWithdraw] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { business } = useCompany();

    const styles = StyleSheet.create({
        page: {
            padding: 30,
            direction: isRTL ? 'rtl' : 'ltr',
            fontFamily: 'Rudaw',
        },
        title: {
            fontSize: 18,
            textAlign: "center",
            fontWeight: "bold",
            marginTop: 10
        },
        infoSection: {
            marginBottom: 20,
            padding: 10,
            border: "1px solid #ccc",
            borderRadius: 5,
            fontSize: 14,
        },
        row: {
            flexDirection: isRTL ? 'row-reverse' : 'row',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        key: {
            fontWeight: 'bold',
            width: '40%',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        value: {
            flex: 1,
            textAlign: isRTL ? 'right' : 'left',
            paddingLeft: 1,
        },
        table: {
            display: "table",
            width: "auto",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#ccc",
            marginBottom: 20,
        },
        tableRow: {
            flexDirection: isRTL ? "row-reverse" : "row",
        },
        tableCell: {
            // flex: 1,
            padding: 5,
            borderRightWidth: 1,
            borderBottomWidth: 1,
            borderColor: "#ccc",
            textAlign: "center",
            fontSize: 10,
        },
        // total: {
        //     textAlign: isRTL ? "left" : "right",
        //     fontSize: 12,
        //     fontWeight: "bold",
        // },
        footer: {
            display: 'flex',
            flexDirection: isRTL ? 'row-reverse' : 'row',
            justifyContent: 'space-between',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
            textAlign: isRTL ? 'right' : 'left',
            fontSize: 12
        },
    });

    const MyDocument = () => {
        const { user, branch, page, driver, type, userType, time } = data;

        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    {/* Title */}
                    <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>
                        <Image src={`${fileApiRoute}/${business.logo}`} style={{ width: 100, height: 50 }} />
                        <View style={{ width: 10 }}></View>
                        <Text style={styles.title}>{t('loanReport')}</Text>
                    </View>

                    {/* Information Section */}
                    <View style={styles.infoSection}>
                        {branch && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('branch')}:</Text>
                                <Text style={styles.value}>{branch.name}</Text>
                            </View>
                        )}
                        {page && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('page')}:</Text>
                                <Text style={styles.value}>{page.name}</Text>
                            </View>
                        )}
                        {driver && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('driver')}:</Text>
                                <Text style={styles.value}>{driver.name}</Text>
                            </View>
                        )}
                        {user && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('user')}:</Text>
                                <Text style={styles.value}>{user.name}</Text>
                            </View>
                        )}
                        {type && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('type')}:</Text>
                                <Text style={styles.value}>{t(type)}</Text>
                            </View>
                        )}
                        {userType && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('userType')}:</Text>
                                <Text style={styles.value}>{t(userType)}</Text>
                            </View>
                        )}
                        {time && (
                            time.time !== '' ?
                                (
                                    <View style={styles.row}>
                                        <Text style={styles.key}>{t('duration')}:</Text>
                                        <Text style={styles.value}>{t(time.time)}</Text>
                                    </View>
                                ) : (
                                    <>
                                        <View style={styles.row}>
                                            <Text style={styles.key}>{t('startDate')}:</Text>
                                            <Text style={styles.value}>
                                                {dayjs(time.from).format('DD/MM/YYYY')}
                                            </Text>
                                        </View>
                                        <View style={styles.row}>
                                            <Text style={styles.key}>{t('endDate')}:</Text>
                                            <Text style={styles.value}>
                                                {dayjs(time.to).format('DD/MM/YYYY')}
                                            </Text>
                                        </View>
                                    </>
                                )
                        )}
                        <View style={styles.row}>
                            <Text style={styles.key}>{t('currentDate')}:</Text>
                            <Text style={styles.value}>
                                {dayjs(new Date()).format('DD/MM/YYYY')}
                            </Text>
                        </View>
                    </View>



                    {/* Table */}
                    <View style={styles.table}>
                        {/* Table Header */}
                        <View style={[styles.tableRow, { backgroundColor: "#f0f0f0" }]}>
                            <Text style={[styles.tableCell, { width: '16%' }]}>{t('customerType')}</Text>
                            <Text style={[styles.tableCell, { width: '16%' }]}>{t('customer')}</Text>
                            <Text style={[styles.tableCell, { width: '17%' }]}>{t('user')}</Text>
                            <Text style={[styles.tableCell, { width: '14%' }]}>{t('amount')}</Text>
                            <Text style={[styles.tableCell, { width: '12%' }]}>{t('type')}</Text>
                            <Text style={[styles.tableCell, { width: '25%' }]}>{t('date')}</Text>
                        </View>

                        {/* Table Rows */}
                        {loans?.map((loan, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: '16%' }]}>{t(loan.userType)}</Text>
                                <Text style={[styles.tableCell, { width: '16%' }]}>
                                    {loan.userType === 'page' ? loan.page?.name : loan.driver?.name}
                                </Text>
                                <Text style={[styles.tableCell, { width: '17%' }]}>{loan.user.name}</Text>
                                <Text style={[styles.tableCell, { width: '14%' }]}>{formatPrice(loan.amount)}</Text>
                                <Text style={[styles.tableCell, { width: '12%' }]}>{loan.type === 'withdraw' ? t('takeMoney') : t(loan.type)}</Text>
                                <Text style={[styles.tableCell, { width: '25%' }]}>{loan.date}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.footer}>
                        <Text style={styles.total}>{t('totalDeposit')}: {formatPrice(totalDeposit)}</Text>
                        <Text style={styles.total}>{t('totalTakeMoney')}: {formatPrice(totalWithdraw)}</Text>
                    </View>
                </Page>
            </Document>
        );
    };


    const fetchLoans = async () => {
        try {
            setIsLoading(true);
            const filters = data && {
                type: data.type,
                userType: data.userType,
                branchId: data.branch && data.branch.id,
                pageId: data.page && data.page.id,
                driverId: data.driver && data.driver.id,
                name: data.name,
                deleted: data.deleted,
                ...data.time,
                sortBy: 'date',
                order: 'asc'
            };

            const responseData = await LoanService.fetchAll(filters);

            setLoans(responseData.loans);
            setTotalDeposit(responseData.totalDeposit);
            setTotalWithdraw(responseData.totalWithdraw);
        } catch (error) {
            console.error("Failed to fetch loans:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrint = async () => {
        registerFont();
        await fetchLoans();
    };

    useEffect(() => {
        if (loans.length > 0) {
            (async () => {
                try {
                    const blob = await pdf(<MyDocument />).toBlob();
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        window.open(url);
                    } else {
                        console.error("Failed to generate PDF blob.");
                    }
                } catch (error) {
                    console.error("Error generating PDF:", error);
                }
            })();
        }
    }, [loans]);

    return (
        // <PDFDownloadLink document={<MyDocument />} fileName="example.pdf">
        isLoading ? <CircularProgress size={28} /> :
            <LocalPrintshopOutlinedIcon sx={{ cursor: 'pointer' }} fontSize="medium" onClick={handlePrint} />
        // </PDFDownloadLink>
    );
}

export default PdfLoanList;